<template>
  <div>
    <Loading :visible="isLoadingPop"></Loading>
    <div class="wrap schedule-change-wrap" v-if="isLoading">
      <div class="top-header">
        <incBack></incBack>
        <h3>일정 변경하기</h3>
      </div>
      <div class="body-wrap">
        <div class="clear mt-40">
          <h4>코칭 방법을 선택해 주세요!</h4>
          <div class="w-100per float-left">
            <ul>
              <li>
                <select name="" id="" v-model="input.sessionType">
                  <option value="">코칭 방법을 선택해 주세요</option>
                  <option value="전화">전화 코칭 (전화)</option>
                  <option value="화상">화상 코칭 (화상)</option>
                  <option value="대면">대면 코칭(오프라인)</option>
                </select>
              </li>
            </ul>
          </div>
        </div>

        <div class="clear mt-40" v-if="input.sessionType == '대면'">
          <h4>어디서 코칭을 받고 싶나요?</h4>
          <div class="w-40per float-left">
            <ul>
              <li>
                <select name="" id="" v-model="tempSi">
                  <option value="">시 전체</option>
                  <option v-for="(item, index) in sido.sido" :key="index" :value="index">{{ item }}</option>
                </select>
              </li>
            </ul>
          </div>
          <div class="w-60per float-left">
            <ul>
              <li>
                <select name="" id="" v-model="tempGu">
                  <option value="">구/동 전체</option>
                  <option :value="index" v-for="(item, index) in sido.gun[tempSi]" :key="index">{{ item }}</option>
                </select>
              </li>
            </ul>
          </div>
        </div>

        <h4>희망 날짜와 시간을 선택해 주세요!</h4>
        <!-- <DatePicker is-expanded style="border:none" locale="en" color="green" v-model="date"></DatePicker> -->
        <DatePicker v-model="schedule.date" is-expanded style="border: none" locale="en" color="green" :min-date="new Date()" />
        <!-- v-model="schedule.startDate" -->
        <!-- :attributes="attributes" -->

        <div class="time-wrap" style="padding-bottom: 50px">
          <h2><img src="@/assets/img/time-icon.svg" alt="" /> Time</h2>
          <select name="time" id="" v-model="schedule.startTime">
            <option value="">시작 시간</option>
            <option :value="item.value" v-for="(item, index) in timeTable" :key="index">{{ item.text }}</option>
          </select>
          <span>~</span>
          <select name="time" id="" v-model="schedule.endTime">
            <option value="">종료 시간</option>
            <option :value="item.value" v-for="(item, index) in timeTable" :key="index">{{ item.text }}</option>
          </select>
        </div>

        <div class="bnb-btn">
          <button class="active" @click="reservationChange()">변경하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import dayjs from "dayjs";
import { sidogun } from "@/utils/sido.js";
import { EmptyCheck } from "@/utils/validation";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "schedule_change",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    date: new Date(),
    schedule: {},
    timeTable: [],
    tempDate: "2022-03-10",
    input: {
      sessionIdx: 0,
      sessionType: "",
      sessionCity: "",
      sessionGu: "",
      startDatetime: "",
      endDatetime: "",
      courseIdx: 0,
    },
    isLoading: false,
    tempSi: "",
    tempGu: "",
    isLoadingPop: false,
  }),
  components: {
    DatePicker,
    incBack,
    Loading,
  },
  // computed:{
  //     dates() {
  //         return this.tempDate.map(day => day.date);
  //     },
  //     attributes() {
  //         return this.dates.map(date => ({
  //             highlight: true,
  //             dates: date,
  //         }));
  //     },
  // },
  mounted() {
    for (let i = 0; i < 24; i++) {
      let time = i < 10 ? "0" + i + ":00" : i + ":00"; // 00 : 00
      let time2 = i < 10 ? "0" + i + ":30" : i + ":30"; // 00 : 30
      this.timeTable.push({ value: time, text: time });
      this.timeTable.push({ value: time2, text: time2 });
    }

    this.sido = sidogun();
    this.getReservationDetail();
  },
  methods: {
    reservationChange() {
      this.schedule.date = dayjs(this.schedule.date).format("YYYY-MM-DD");

      if (!EmptyCheck(this.input.sessionType, "코칭 방법을")) {
        return false;
      }
      if (!EmptyCheck(this.schedule.date, "희망 날짜를")) {
        return false;
      }
      if (!EmptyCheck(this.schedule.startTime, "희망 시작 시간을")) {
        return false;
      }
      if (!EmptyCheck(this.schedule.endTime, "희망 종료 시간을")) {
        return false;
      }

      this.input.sessionIdx = this.sessionIdx;
      if (this.input.sessionType == "대면") {
        this.input.sessionCity = this.sido.sido[this.tempSi];
        this.input.sessionGu = this.sido.gun[this.tempSi][this.tempGu];
      }
      this.input.startDatetime = this.schedule.date + " " + this.schedule.startTime + ":00";
      this.input.endDatetime = this.schedule.date + " " + this.schedule.endTime + ":00";
      this.input.courseIdx = this.schedule.courseIdx;
      if (new Date() > new Date(this.input.startDatetime)) {
        alert("시간을 확인해주세요.");
        return false;
      }
      if (new Date(this.input.endDatetime) < new Date(this.input.startDatetime)) {
        alert("시간을 확인해주세요.");
        return false;
      }
      this.isLoadingPop = true;

      let form = new FormData();
      for (const [key, value] of Object.entries(this.input)) {
        form.append(key, value);
      }

      this.axios
        .post("/front/coarch/reserved/edit/date", form)
        .then((res) => {
          if (res.data.success) {
            alert("예약된 코칭 일정이 변경되었습니다.");
            this.isLoadingPop = false;
            this.$router.go(-1);
          } else {
            alert("예약 변경 실패");
            this.isLoadingPop = false;
          }
        })
        .catch((err) => {
          alert("예약 변경 실패");
          this.isLoadingPop = false;
          console.log(err);
        });
    },
    getReservationDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.schedule = res.data.contentinfo.coarchReservationList;
            this.schedule.date = new Date(dayjs(this.schedule.startDate).format("YYYY-MM-DD"));
            this.schedule.startTime = dayjs(this.schedule.startDate).format("HH:mm");
            this.schedule.endTime = dayjs(this.schedule.endDate).format("HH:mm");
            this.isLoading = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    change() {
      this.$router.push("reservation_coaching_view");
    },
  },
};
</script>
<style scoped>
.vc-container {
  --day-content-height: 50px;
  --day-content-width: 50px;
}
</style>
